module.exports = __webpack_public_path__ + "img/monk.a6f2667a.png";